import { render, staticRenderFns } from "./CouponcodeList.vue?vue&type=template&id=2713a21b&"
import script from "./CouponcodeList.vue?vue&type=script&lang=js&"
export * from "./CouponcodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports